import {
	ControlledInput,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@dune/ui";
import { useFormContext } from "react-hook-form";

interface GFAFinancingsDetailsContainerProps {
	isForm?: boolean;
}

const GFAFinancingsDetailsContainer = ({
	isForm = true,
}: GFAFinancingsDetailsContainerProps) => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	return (
		<div className="w-full border rounded-lg">
			<Table>
				<TableHeader>
					<TableRow>
						<TableHead
							className={`${
								isForm ? "w-3/4" : "w-1/2"
							} font-semibold text-gray-900`}
						/>
						<TableHead className="p-4 font-semibold text-gray-900">
							HT
						</TableHead>
						<TableHead className="p-4 font-semibold text-gray-900">
							TTC
						</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{/* Prix de Vente Prévisionnel */}
					<TableRow>
						<TableCell className="p-4 font-medium bg-gray-100">
							Prix de Vente Prévisionnel*
							{errors.estimatedSalePriceTTC && (
								<p className="text-red-500">
									{errors.estimatedSalePriceTTC.message?.toString()}
								</p>
							)}
						</TableCell>
						<TableCell className="p-4">
							<ControlledInput
								name="estimatedSalePriceHT"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
						<TableCell>
							<ControlledInput
								name="estimatedSalePriceTTC"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
					</TableRow>

					{/* Coût de revient */}
					<TableRow>
						<TableCell className="p-4 font-medium bg-gray-100">
							Coût de revient *
							{errors.costPriceTTC && (
								<p className="text-red-500">
									{errors.costPriceTTC.message?.toString()}
								</p>
							)}
						</TableCell>
						<TableCell className="p-4 ">
							<ControlledInput
								name="costPriceHT"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
						<TableCell>
							<ControlledInput
								name="costPriceTTC"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
					</TableRow>

					{/* Dont : (Section header) */}
					<TableRow className="bg-gray-50 h-14">
						<TableCell className="p-4 font-medium">Dont :</TableCell>
						<TableCell className="p-4 " />
						<TableCell />
					</TableRow>

					{/* Foncier */}
					<TableRow>
						<TableCell className="p-4 bg-gray-100">
							Foncier (y compris coût de transactions)
							{errors.landCostTTC && (
								<p className="text-red-500">
									{errors.landCostTTC.message?.toString()}
								</p>
							)}
						</TableCell>
						<TableCell className="p-4 ">
							<ControlledInput
								name="landCostHT"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
						<TableCell>
							<ControlledInput
								name="landCostTTC"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
					</TableRow>

					{/* Etudes et Honoraires Techniques */}
					<TableRow>
						<TableCell className="p-4 bg-gray-100">
							Etudes et Honoraires Techniques
							{errors.studiesAndTechnicalFeesTTC && (
								<p className="text-red-500">
									{errors.studiesAndTechnicalFeesTTC.message?.toString()}
								</p>
							)}
						</TableCell>
						<TableCell className="p-4 ">
							<ControlledInput
								name="studiesAndTechnicalFeesHT"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
						<TableCell>
							<ControlledInput
								name="studiesAndTechnicalFeesTTC"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
					</TableRow>

					{/* Coûts des travaux */}
					<TableRow>
						<TableCell className="p-4 bg-gray-100">
							Coûts des travaux
							{errors.constructionCostsTTC && (
								<p className="text-red-500">
									{errors.constructionCostsTTC.message?.toString()}
								</p>
							)}
						</TableCell>
						<TableCell className="p-4 ">
							<ControlledInput
								name="constructionCostsHT"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
						<TableCell>
							<ControlledInput
								name="constructionCostsTTC"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
					</TableRow>

					{/* Dont aléas */}
					<TableRow>
						<TableCell className="p-4 bg-gray-100">
							Dont aléas
							{errors.contingenciesTTC && (
								<p className="text-red-500">
									{errors.contingenciesTTC.message?.toString()}
								</p>
							)}
						</TableCell>
						<TableCell className="p-4 ">
							<ControlledInput
								name="contingenciesHT"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
						<TableCell>
							<ControlledInput
								name="contingenciesTTC"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
					</TableRow>

					{/* Honoraires de Gestion du promoteur */}
					<TableRow>
						<TableCell className="p-4 bg-gray-100">
							Honoraires de Gestion du promoteur
							{errors.developerManagementFeesTTC && (
								<p className="text-red-500">
									{errors.developerManagementFeesTTC.message?.toString()}
								</p>
							)}
						</TableCell>
						<TableCell className="p-4 ">
							<ControlledInput
								name="developerManagementFeesHT"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
						<TableCell>
							<ControlledInput
								name="developerManagementFeesTTC"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
					</TableRow>

					{/* Frais de commercialisation */}
					<TableRow>
						<TableCell className="p-4 bg-gray-100">
							Frais de commercialisation
							{errors.marketingCostsTTC && (
								<p className="text-red-500">
									{errors.marketingCostsTTC.message?.toString()}
								</p>
							)}
						</TableCell>
						<TableCell className="p-4 ">
							<ControlledInput
								name="marketingCostsHT"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
						<TableCell>
							<ControlledInput
								name="marketingCostsTTC"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
					</TableRow>

					{/* Assurances et Divers */}
					<TableRow>
						<TableCell className="p-4 bg-gray-100">
							Assurances et Divers
							{errors.insuranceAndMiscellaneousTTC && (
								<p className="text-red-500">
									{errors.insuranceAndMiscellaneousTTC.message?.toString()}
								</p>
							)}
						</TableCell>
						<TableCell className="p-4 ">
							<ControlledInput
								name="insuranceAndMiscellaneousHT"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
						<TableCell>
							<ControlledInput
								name="insuranceAndMiscellaneousTTC"
								control={control}
								type="number"
								step="0.01"
								placeholder="X"
								iconOrText="€"
								iconOrTextPosition="right"
								className=" border-0 shadow-none bg-transparent h-auto p-0 focus-visible:ring-0 focus-visible:border-0"
								formatThousands={true}
								disabled={!isForm}
							/>
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</div>
	);
};

export default GFAFinancingsDetailsContainer;
